import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  background: #ffffff00;
  padding: 1.5rem;
  margin-top: 2.4rem;
`;

export const Content = styled.div`
  width: 100%;
  background: #ffffff;
  padding: 32px 0px 0px 32px;
`;

export const ContentEmpresa = styled.div`
  width: 100%;
  background: #ffffff00;
  padding: 0px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  button {
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    gap: 0.25rem;
    color: #4f5b66;
    font-size: 1.25rem;
    cursor: pointer;
  }
`;

export const PeriodFilters = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;

  button {
    border: 1px solid #ec6643;
    background: #fff;
    color: #ec6643;
    border-radius: 999px;
    padding: 0.55rem 1rem;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    transition: 0.2s ease;

    &:hover {
      background: #ec6643;
      color: #fff;
      transform: translateY(-1px);
    }

    &.active {
      background: #ec6643;
      color: #fff;
      box-shadow: 0 4px 12px rgba(236, 102, 67, 0.25);
    }
  }
`;

export const Tabs = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding: 0px 32px 0px 0px;

  button {
    all: unset;
    border-radius: 21px;
    padding: 0.75rem 1.5rem;
    border-bottom: 1px solid #EC6643;
    font-size: 0.875rem;
    font-weight: 500;
    color: #EC6643;
    white-space: nowrap;
    cursor: pointer;
  }
`;

export const SummaryCard = styled.div`
  background: #fff;
  padding: 1.5rem;
  display: grid;
  grid-template-columns: 220px 1fr 220px;
  gap: 2rem;
  align-items: center;
  margin-bottom: 1rem;
`;

export const TickerBadge = styled.div`
  display: inline-block;
  background: #ec6643;
  color: #fff;
  border-radius: 16px;
  padding: 0.5rem 0.75rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
`;

export const LogoPlaceholder = styled.div`
  width: 110px;
  height: 110px;
  background: #5a9bd8;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(180px, 1fr));
  gap: 1.25rem 2rem;
`;

export const InfoGridETF = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(150px, 1fr));
  gap: 1.4rem 2.5rem;
  width: 100%;
`;

export const InfoItem = styled.div`
  font-size: 0.875rem;

  span {
    color: #ec6643;
    display: block;
    margin-bottom: 0.25rem;
  }

  strong {
    color: #111827;
  }
`;

export const ScoreContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  h6 {
    position: absolute;
    font-size: 1rem;
    font-weight: 700;
    color: #111827;
  }
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(220px, 1fr));
  gap: 1rem;
`;

export const MetricCard = styled.div`
  background: #fff;
  border-radius: 6px;
  padding: 1rem;
  min-height: 130px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    transform: translateY(-2px);
  }

  header {
    display: flex;
    justify-content: space-between;
    font-weight: 700;
    font-size: 0.875rem;
    margin-bottom: 1rem;
  }

  h3 {
    font-size: 1.5rem;
    margin: 0;
    color: #111827;
  }
`;

export const LoadingMessage = styled.div`
  padding: 2rem;
  color: #4f5b66;
  margin-top: 2.6rem;
`;

export const CompanyAboutCard = styled.div`
  width: 100%;
  background: #fff;
  margin-top: 1rem;
  padding: 1.5rem;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
`;

export const CompanyAboutHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  margin-bottom: 1rem;

  h2 {
    margin: 0;
    color: #111827;
    font-size: 1.25rem;
  }

  span {
    color: #ec6643;
    font-size: 0.875rem;
    font-weight: 600;
    display: block;
    margin-bottom: 0.25rem;
  }
`;

export const CompanyDescription = styled.p`
  color: #4f5b66;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

export const CompanySiteLink = styled.a`
  color: #ec6643;
  font-weight: 700;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;